import React from "react";
import "../../asset/css/App.css";
import selogo from "../../asset/images/selogo.png"

const Header = () => {
  return (
    <>
      <div className="header">
                <div className="main_logo_event main-logo" >
                    <img src={selogo} /> 
                    <label>EZ Selector</label>
                </div>
            </div>
    </>
  );
};

export default Header;
